// import React, { useContext, useEffect, useState, useRef , useCallback } from 'react';
// import {
//   AppBar,
//   Avatar,
//   Box,
//   IconButton,
//   Toolbar,
//   Typography,
//   Paper,
//   TextField,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Divider,
//   Badge,
//   Chip,
// } from '@mui/material';
// import { Send, ArrowBack, MoreVert, Search } from '@mui/icons-material';
// import { BASE_URL, Notification_Url } from './../../Api/ApiUrls';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from './../../AuthContext/AuthContext';
// import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';

// const BuyChatWindow = () => {
//   const { userId, userName } = useContext(AuthContext);
//   const { propertyId, customerid } = useParams();

//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState('');
//   const [customerName, setCustomerName] = useState('');
//   const [propertyDetails, setPropertyDetails] = useState(null);
//   const [propertyCategory, setPropertyCategory] = useState(null);
//   const messagesEndRef = useRef(null);
//   const navigate = useNavigate();

//   // Format price in INR
//   const formatPriceINR = (price) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       maximumFractionDigits: 0,
//     }).format(price);
//   };

//   // Format time
//   const formatTime = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//   };

//   // Fetch property details
//   // const fetchPropertyDetails = async () => {
//   //   if (!propertyId) return;
    
//   //   try {
//   //     const res = await axios.get(`${BASE_URL}/property/${propertyId}/`);
//   //     setPropertyDetails(res.data);
//   //   } catch (error) {
//   //     console.error('Error loading property:', error);
//   //     setPropertyDetails({
//   //       property_name: `Property ${propertyId}`,
//   //       price: 0,
//   //       type: 'sell'
//   //     });
//   //   }
//   // };
//   //  const fetchPropertyDetails = useCallback(async () => {
//   //   try {
//   //     const response = await axios.get(`${BASE_URL}/property/${propertyId}/`);
//   //     setPropertyDetails(response.data);
      
//   //     // Fetch category details if category_id exists
//   //     if (response.data.category_id) {
//   //       const categoryResponse = await axios.get(`${BASE_URL}/property-category/`);
//   //       const category = categoryResponse.data.find(
//   //         cat => cat.category_id === response.data.category_id
//   //       );
//   //       setPropertyCategory(category);
//   //     }
//   //   } catch (err) {
//   //     console.error('Failed to fetch property details:', err);
//   //   }
//   // }, [propertyId]);

//   const fetchPropertyDetails = useCallback(async () => {
//   try {
//     const response = await axios.get(`${BASE_URL}/property/${propertyId}/`);

//     setPropertyDetails(response.data);
//     setPropertyCategory(response.data.category_name);

//   } catch (err) {
//     console.error("Failed to fetch property details:", err);
//   }
// }, [propertyId]);

  
// const fetchChat = async () => {
//   try {
//     console.log('📥 Fetching chat messages...');

//     console.log('🔍 Expected propertyId:', propertyId, typeof propertyId);
//     console.log('🔍 Expected userId:', userId, typeof userId);
//     console.log('🔍 Expected customerid:', customerid, typeof customerid);

//     const res = await axios.get(`${BASE_URL}/chat-messages/`);
//     console.log('📦 All chat messages:', res.data);

//     const filtered = res.data.filter(msg =>
//       Number(msg.property_id) === Number(propertyId) &&
//       (
//         (Number(msg.user_id) === Number(userId) && Number(msg.receiver) === Number(customerid)) ||
//         (Number(msg.user_id) === Number(customerid) && Number(msg.receiver) === Number(userId))
//       )
//     );

//     console.log('✅ Filtered messages:', filtered);
//     setMessages(filtered);

//     // Auto-scroll to bottom
//     setTimeout(() => {
//       if (messagesEndRef.current) {
//         messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
//         console.log('📜 Scrolled to bottom');
//       }
//     }, 100);

//   } catch (error) {
//     console.error('❌ Error loading chat:', error);
//   }
// };




//   // Fetch customer details
//   const fetchCustomerDetails = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/users/${customerid}/`);
//       setCustomerName(res.data.username || `User ${customerid}`);
//     } catch (error) {
//       console.error('Error loading customer details:', error);
//       setCustomerName(`User ${customerid}`);
//     }
//   };

// const handleSend = async () => {
//   if (!newMessage.trim()) return;

//   const messageToSend = newMessage; // Store message before clearing
//   setNewMessage(''); // Clear immediately

//   try {
//     await axios.post(`${BASE_URL}/chat-messages/`, {
//       user_id: userId,
//       receiver: customerid,
//       message: messageToSend, // Use stored message
//       property_id: propertyId || null,
//     });

//     fetchChat();

//     // Send notification
//     const userRes = await axios.get(`${BASE_URL}/users/${customerid}/`);
//     const receiverData = userRes.data;
//     const fcmToken = receiverData.fcm_token;

//     // if (fcmToken) {
//     //   await axios.post(`${Notification_Url}/send-notification`, {
//     //     token: fcmToken,
//     //     title: `Message from ${userName}`,
//     //     body: messageToSend, // Use stored message
//     //     id: userId
//     //   });
//     // }
//   } catch (error) {
//     console.error('Failed to send:', error);
//   }
// };

//   // Handle property click navigation
//   const handlePropertyClick = () => {
//     if (!propertyDetails) return;

//     let route = '';
//     switch (propertyDetails.type) {
//       case 'sell':
//         route = '/Buy-description';
//         break;
//       case 'best-deal':
//         route = '/hot-property-description';
//         break;
//       case 'rent':
//         route = '/rent-description';
//         break;
//       case 'lease':
//         route = '/lease-description';
//         break;
//       default:
//         route = '/new-description';
//     }

//     navigate(route, {
//       state: {
//         propertyId: propertyId,
//         property: propertyDetails
//       }
//     });
//   };

//   useEffect(() => {
//     fetchPropertyDetails();
//     fetchCustomerDetails();
//     fetchChat();
    
//     const interval = setInterval(fetchChat, 5000);
//     return () => clearInterval(interval);
//   }, [propertyId, customerid]);

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         maxWidth: 800,
//         mx: 'auto',
//         height: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         bgcolor: '#e5ddd5',
//         backgroundImage: 'url("https://web.whatsapp.com/img/bg-chat-tile-light_a4be512e7195b6b733d9110b408f075d.png")',
//       }}
//     >
//       {/* Header */}
//       <AppBar
//         position="sticky"
//         elevation={0}
//         sx={{
//           bgcolor: '#075e54',
//           color: 'white',
//         }}
//       >
//         <Toolbar sx={{ bgcolor: 'black', color: 'white' }}>
//           <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
//             <ArrowBack />
//           </IconButton>
//           <ListItemText
//             primary={customerName}
//             secondary="Online"
//             sx={{ color: 'white' }}
//             primaryTypographyProps={{ fontWeight: 'bold' }}
//             secondaryTypographyProps={{ fontSize: '0.75rem' }}
//           />
//           <IconButton edge="end" color="inherit">
//             <MoreVert />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       {/* Property Header */}
//       {propertyDetails && (
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             px: 2,
//             py: 1,
//             bgcolor: '#f5f5f5',
//             borderBottom: '1px solid #ccc',
//             cursor: 'pointer',
//           }}
//           onClick={handlePropertyClick}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
//             {propertyCategory && (
//                <Typography 
//                  variant="body2" 
//                  fontWeight="bold" 
//                  color="text.secondary"
//                  sx={{
//                    whiteSpace: 'nowrap',
//                    overflow: 'hidden',
//                    textOverflow: 'ellipsis',
//                    '&:hover': {
//                      textDecoration: 'underline',
//                    }
//                  }}
//                >
//                  {propertyDetails.category_name} - {propertyDetails.property_name}
//                </Typography>
//              )}
//             <Typography sx={{ fontWeight: 500, ml: 1 }}>
//               {formatPriceINR(propertyDetails.price)}
//             </Typography>
//           </Box>
//         </Box>
//       )}

//       {/* Chat Messages */}
//       <Box
//         sx={{
//           flexGrow: 1,
//           overflowY: 'auto',
//           p: 2,
//           display: 'flex',
//           flexDirection: 'column',
//         }}
//       >
//         <List sx={{ width: '100%' }}>
//           {messages.map((msg, idx) => (
//             <React.Fragment key={idx}>
//               <ListItem
//                 sx={{
//                   justifyContent: msg.user_id == userId ? 'flex-end' : 'flex-start',
//                   px: 0,
//                   py: 0.5,
//                 }}
//               >
//                 {msg.user_id !== userId && (
//                   <ListItemAvatar>
//                     <Avatar src={`https://i.pravatar.cc/150?u=${msg.user_id}`} />
//                   </ListItemAvatar>
//                 )}
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     maxWidth: '75%',
//                   }}
//                 >
//                   <Paper
//                     sx={{
//                       p: 1.5,
//                       borderRadius:
//                         msg.user_id == userId
//                           ? '18px 18px 0 18px'
//                           : '18px 18px 18px 0',
//                       bgcolor: msg.user_id == userId ? '#dcf8c6' : 'white',
//                     }}
//                   >
//                     <Typography variant="body1">{msg.message}</Typography>
//                   </Paper>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       alignSelf: msg.user_id == userId ? 'flex-end' : 'flex-start',
//                       color: 'text.secondary',
//                       mt: 0.5,
//                     }}
//                   >
//                     {formatTime(msg.created_at)}
//                     {msg.user_id == userId && (
//                       <span style={{ marginLeft: 4 }}>
//                         {msg.is_read ? '✓✓' : '✓'}
//                       </span>
//                     )}
//                   </Typography>
//                 </Box>
//               </ListItem>
//             </React.Fragment>
//           ))}
//           <div ref={messagesEndRef} />
//         </List>
//       </Box>

//       {/* Message Input */}
//       <Box
//         sx={{
//           p: 1,
//           bgcolor: '#f0f0f0',
//           display: 'flex',
//           alignItems: 'center',
//           marginBottom: '22%',
//         }}
//       >
//         <TextField
//           fullWidth
//           variant="outlined"
//           size="small"
//           placeholder="Type a message"
//           value={newMessage}
//           onChange={(e) => setNewMessage(e.target.value)}
//           onKeyPress={(e) => e.key === 'Enter' && handleSend()}
//           sx={{
//             bgcolor: 'white',
//             borderRadius: 20,
//             '& .MuiOutlinedInput-root': {
//               borderRadius: 20,
//               paddingRight: 1,
//             },
//             border: '2px solid black',
//           }}
//           InputProps={{
//             endAdornment: (
//               <IconButton
//                 color="primary"
//                 onClick={handleSend}
//                 disabled={!newMessage.trim()}
//               >
//                 <Send sx={{ color: 'black' }} />
//               </IconButton>
//             ),
//           }}
//         />
//       </Box>
//       <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
//         <FormsBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default BuyChatWindow;

import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  Paper,
  TextField,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import { Send, ArrowBack, MoreVert } from '@mui/icons-material';
import { BASE_URL, Notification_Url } from './../../Api/ApiUrls';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './../../AuthContext/AuthContext';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';

const BuyChatWindow = () => {
  const { userId, userName } = useContext(AuthContext);
  const { propertyId, customerid } = useParams();

  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [propertyCategory, setPropertyCategory] = useState(null);
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();

  const formatPriceINR = (price) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const fetchPropertyDetails = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/property/${propertyId}/`);
      setPropertyDetails(response.data);
      setPropertyCategory(response.data.category_name);
    } catch (err) {
      console.error("Failed to fetch property details:", err);
    }
  }, [propertyId]);

  const fetchChat = useCallback(async () => {
    try {
      const res = await axios.get(`${BASE_URL}/chat-messages/`);
      const filtered = res.data.filter(msg =>
        Number(msg.property_id) === Number(propertyId) &&
        (
          (Number(msg.user_id) === Number(userId) && Number(msg.receiver) === Number(customerid)) ||
          (Number(msg.user_id) === Number(customerid) && Number(msg.receiver) === Number(userId))
        )
      );
      setMessages(filtered);

      setTimeout(() => {
        if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } catch (error) {
      console.error('❌ Error loading chat:', error);
    }
  }, [propertyId, userId, customerid]);

  const fetchCustomerDetails = useCallback(async () => {
    try {
      const res = await axios.get(`${BASE_URL}/users/${customerid}/`);
      setCustomerName(res.data.username || `User ${customerid}`);
    } catch (error) {
      console.error('Error loading customer details:', error);
      setCustomerName(`User ${customerid}`);
    }
  }, [customerid]);

  const handleSend = async () => {
    if (!newMessage.trim()) return;

    const messageToSend = newMessage;
    setNewMessage('');

    try {
      await axios.post(`${BASE_URL}/chat-messages/`, {
        user_id: userId,
        receiver: customerid,
        message: messageToSend,
        property_id: propertyId || null,
      });

      fetchChat();

      const userRes = await axios.get(`${BASE_URL}/users/${customerid}/`);
      const receiverData = userRes.data;
      const fcmToken = receiverData.fcm_token;

      if (fcmToken) {
        await axios.post(`${Notification_Url}/send-notification`, {
          token: fcmToken,
          title: `Message from ${userName}`,
          body: messageToSend,
          id: userId
        });
      }
    } catch (error) {
      console.error('Failed to send:', error);
    }
  };

  const handlePropertyClick = () => {
    if (!propertyDetails) return;

    let route = '';
    switch (propertyDetails.type) {
      case 'sell': route = '/Buy-description'; break;
      case 'best-deal': route = '/hot-property-description'; break;
      case 'rent': route = '/rent-description'; break;
      case 'lease': route = '/lease-description'; break;
      default: route = '/new-description';
    }

    navigate(route, {
      state: {
        propertyId: propertyId,
        property: propertyDetails
      }
    });
  };

  useEffect(() => {
    if (propertyId && customerid) {
      fetchPropertyDetails();
      fetchCustomerDetails();
      fetchChat();
      
      const interval = setInterval(fetchChat, 5000);
      return () => clearInterval(interval);
    }
  }, [propertyId, customerid, fetchPropertyDetails, fetchCustomerDetails, fetchChat]);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 800,
        mx: 'auto',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#e5ddd5',
        backgroundImage: 'url("https://web.whatsapp.com/img/bg-chat-tile-light_a4be512e7195b6b733d9110b408f075d.png")',
      }}
    >
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#075e54', color: 'white' }}>
        <Toolbar sx={{ bgcolor: 'black', color: 'white' }}>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <ListItemText
            primary={customerName}
            secondary="Online"
            sx={{ color: 'white' }}
            primaryTypographyProps={{ fontWeight: 'bold' }}
            secondaryTypographyProps={{ fontSize: '0.75rem' }}
          />
          <IconButton edge="end" color="inherit">
            <MoreVert />
          </IconButton>
        </Toolbar>
      </AppBar>

      {propertyDetails && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1,
            bgcolor: '#f5f5f5',
            borderBottom: '1px solid #ccc',
            cursor: 'pointer',
          }}
          onClick={handlePropertyClick}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', overflow: 'hidden' }}>
            {propertyCategory && (
               <Typography 
                 variant="body2" 
                 fontWeight="bold" 
                 color="text.secondary"
                 sx={{
                   whiteSpace: 'nowrap',
                   overflow: 'hidden',
                   textOverflow: 'ellipsis',
                   '&:hover': { textDecoration: 'underline' }
                 }}
               >
                 {propertyDetails.category_name} - {propertyDetails.property_name}
               </Typography>
             )}
            <Typography sx={{ fontWeight: 500, ml: 1 }}>
              {formatPriceINR(propertyDetails.price)}
            </Typography>
          </Box>
        </Box>
      )}

      <Box
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <List sx={{ width: '100%' }}>
          {messages.map((msg, idx) => (
            <React.Fragment key={idx}>
              <ListItem
                sx={{
                  justifyContent: msg.user_id == userId ? 'flex-end' : 'flex-start',
                  px: 0,
                  py: 0.5,
                }}
              >
                {msg.user_id !== userId && (
                  <ListItemAvatar>
                    <Avatar src={`https://i.pravatar.cc/150?u=${msg.user_id}`} />
                  </ListItemAvatar>
                )}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: '75%',
                  }}
                >
                  <Paper
                    sx={{
                      p: 1.5,
                      borderRadius:
                        msg.user_id == userId
                          ? '18px 18px 0 18px'
                          : '18px 18px 18px 0',
                      bgcolor: msg.user_id == userId ? '#dcf8c6' : 'white',
                    }}
                  >
                    <Typography variant="body1">{msg.message}</Typography>
                  </Paper>
                  <Typography
                    variant="caption"
                    sx={{
                      alignSelf: msg.user_id == userId ? 'flex-end' : 'flex-start',
                      color: 'text.secondary',
                      mt: 0.5,
                    }}
                  >
                    {formatTime(msg.created_at)}
                    {msg.user_id == userId && (
                      <span style={{ marginLeft: 4 }}>
                        {msg.is_read ? '✓✓' : '✓'}
                      </span>
                    )}
                  </Typography>
                </Box>
              </ListItem>
            </React.Fragment>
          ))}
          <div ref={messagesEndRef} />
        </List>
      </Box>

      <Box
        sx={{
          p: 1,
          bgcolor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          marginBottom: '22%',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Type a message"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSend()}
          sx={{
            bgcolor: 'white',
            borderRadius: 20,
            '& .MuiOutlinedInput-root': {
              borderRadius: 20,
              paddingRight: 1,
            },
            border: '2px solid black',
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                color="primary"
                onClick={handleSend}
                disabled={!newMessage.trim()}
              >
                <Send sx={{ color: 'black' }} />
              </IconButton>
            ),
          }}
        />
      </Box>
      <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
};

export default BuyChatWindow;